// =============================================================================
// src/lib/emptyIcons.js
//
// Which line icon an <EmptyState icon="..."> string draws (Oct 2026).
// Call sites pass a word ("check", "People") or an emoji. EmptyState used to
// print the string itself as 36px grey text, so Today said "check" and
// Schedule said "People". This resolves the string to an icon NAME; ui.jsx
// maps names to components from components/icons.jsx. Unknown strings give
// null, and EmptyState then draws its default mark - never the raw text.
// Plain .js (no JSX) so the unit test can import it.
// =============================================================================
const MAP = {
  check: "check", ok: "check", done: "check", "\u2705": "check", "\u2713": "check", "\u2714": "check",
  people: "users", users: "users", "\ud83d\udc65": "users", "\ud83d\udc64": "users", "\ud83e\udd1d": "users",
  clipboard: "clipboard", "\ud83d\udccb": "clipboard",
  calendar: "calendar", "\ud83d\udcc5": "calendar", "\ud83d\udcc6": "calendar", "\ud83d\uddd3": "calendar",
  edit: "edit", note: "edit", "\ud83d\udcdd": "edit", "\u270d": "edit",
  chart: "chart", "\ud83d\udcca": "chart", "\ud83d\udcc8": "chart", "\u25a7": "chart",
  sparkles: "sparkles", ai: "sparkles", "\u2728": "sparkles",
  phone: "phone", "\ud83d\udcde": "phone", "\u260e": "phone",
  pill: "pill", medication: "pill", "\ud83d\udc8a": "pill",
  lab: "flask", "\ud83e\uddea": "flask",
  map: "map", "\ud83e\udded": "map", "\ud83d\udccd": "map",
  shield: "shield", "\ud83d\udee1": "shield",
  search: "search", "\ud83d\udd0e": "search", "\ud83d\udd0d": "search",
  bell: "bell", "\ud83d\udce3": "bell", "\ud83d\udd14": "bell",
  message: "message", "\ud83d\udcac": "message",
  inbox: "inbox", mail: "inbox", "\u2709": "inbox", "\ud83d\udce5": "inbox", "\ud83d\udce8": "inbox",
  clock: "clock", "\ud83d\udd52": "clock", "\u23f8": "clock", "\u23f3": "clock",
  receipt: "receipt", "\ud83e\uddfe": "receipt",
  door: "door", "\ud83d\udeaa": "door",
  box: "layers", "\ud83d\udce6": "layers",
  file: "file", "\ud83d\udcdc": "file", "\ud83d\udcc4": "file",
  card: "card", "\ud83d\udcb3": "card",
};

export function emptyIconName(icon) {
  if (typeof icon !== "string") return null;
  const key = icon.replace(/\ufe0f/g, "").trim();
  return MAP[key] || MAP[key.toLowerCase()] || null;
}
